import { getModal } from './dom';

const $ = jQuery;

/**
 * Safely destroy Select2 if it exists
 * @param $select
 */
export function destroySelect2($select) {
	if (!$select || !$select.length) {
		return;
	}

	try {
		if ($select.data('select2')) {
			$select.select2('destroy');
		}
	} catch (e) {
		// silent on purpose
	}
}

/**
 * Reset select element completely
 * @param $select
 */
export function resetSelect($select) {
	destroySelect2($select);
	$select.empty().off();
}

function repositionDropdown($obj) {
	// Force dropdown reposition after height change
	const instance = $obj.data('select2');
	if (instance && instance.isOpen()) {
		setTimeout(() => {
			instance.dropdown._positionDropdown();
		}, 0);
	}
}

/**
 * Initialize condition Select2 with AJAX
 * @param $select
 * @param config
 */
export function initConditionSelect($select, config = {}) {
	const { ajaxurl, nonce, object_type, target, items = [] } = config;

	if (!target || target.startsWith('all__')) {
		return;
	}

	resetSelect($select);

	$select.select2({
		placeholder: 'Type to search products...',
		multiple: true,
		width: '100%',
		dropdownParent: getModal(),
		minimumResultsForSearch: 0,
		closeOnSelect: false,
		ajax: {
			url: ajaxurl,
			dataType: 'json',
			delay: 250,
			data(params) {
				return {
					action: 'snap_blocks_select2_search',
					security: nonce,
					object_type,
					target,
					q: params.term || '',
				};
			},
			processResults(response) {
				return {
					results: response.data || [],
				};
			},
		},
	});

	// Hydrate existing items
	if (Array.isArray(items) && items.length) {
		items.forEach((item) => {
			const option = new Option(item.text, item.id, true, true);
			$select.append(option);
		});
		$select.trigger('change');
	}

	// Keep search field focused at all times
	let searchField = null;

	$select.on('select2:open', function (e) {
		// Find the search field for THIS specific select2 instance
		const container = $(e.target).data('select2').$container[0];
		searchField = container.querySelector('.select2-search__field');

		if (searchField) {
			// Multiple attempts to ensure focus
			const focusSearch = () => {
				if (searchField && document.activeElement !== searchField) {
					searchField.focus();
				}
			};

			// Immediate focus
			focusSearch();

			// Delayed focus to override Select2
			setTimeout(focusSearch, 0);
			setTimeout(focusSearch, 10);
			setTimeout(focusSearch, 50);

			// Keep re-focusing if it loses focus
			const focusInterval = setInterval(() => {
				if (searchField && $(e.target).data('select2').isOpen()) {
					focusSearch();
				} else {
					clearInterval(focusInterval);
				}
			}, 100);

			// Store interval for cleanup
			$(e.target).data('focusInterval', focusInterval);
		}

		repositionDropdown($(this));
	});

	// Clean up interval when closed
	$select.on('select2:close', function (e) {
		const focusInterval = $(e.target).data('focusInterval');
		if (focusInterval) {
			clearInterval(focusInterval);
		}
	});

	// Re-focus after selection
	$select.on('select2:select select2:unselect', function (e) {
		const container = $(e.target).data('select2').$container[0];
		const field = container.querySelector('.select2-search__field');
		if (field) {
			setTimeout(() => field.focus(), 0);
		}

		repositionDropdown($(this));
	});
}
